import Component from 'components/component';
import { Screen } from 'components/screen';

export class Widget extends Component {
  protected screen: Screen;
  protected el: HTMLElement;

  constructor(screen: Screen, el: HTMLElement) {
    super();

    this.screen = screen;
    this.el = el;
  }
}

export default Widget;
